import { FC, useContext, useState, memo, useEffect } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { MobileDateRangePicker } from '@mui/x-date-pickers-pro';
import { useTranslation } from 'react-i18next';

import { DateRangeProps } from './types';
import { FILTER_BY } from 'constants/filter';
import { AppContext } from 'context';
import { preventBodyScrollOnModal } from 'services/preventBodyScrollOnModal';

const DateRangePicker: FC<DateRangeProps> = memo(({ open, setOpen }: DateRangeProps) => {
    const { t } = useTranslation();
    const {
        setFilterType,
        filterType: { dateRange },
    } = useContext(AppContext);

    const [range, setRange] = useState<[null | Date, null | Date]>([
        dateRange ? dateRange[0] : null,
        dateRange ? dateRange[1] : null,
    ]);

    useEffect(() => {
        if (range[0] !== dateRange[0] || range[1] !== dateRange[1]) {
            setRange(dateRange);
        }
    }, [dateRange]);

    // Prevent body scroll when dialog is open
    useEffect(() => {
        return preventBodyScrollOnModal(open);
    }, [open]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        if (range[0] || range[1]) {
            setFilterType((filterType) => ({ ...filterType, filterBy: FILTER_BY.DateRange, dateRange: range }));
        }
        setOpen(false);
    };

    return (
        <>
            <Dialog onClose={handleClose} open={open} aria-labelledby='customized-dialog-title'>
                <DialogTitle id='customized-dialog-title'>{t('form.date_range')}</DialogTitle>
                <DialogContent>
                    <MobileDateRangePicker
                        value={range}
                        onChange={setRange}
                        slots={{
                            textField: (params) => (
                                <>
                                    <TextField {...params} variant='standard' />
                                </>
                            ),
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSave} variant='contained' color='primary'>
                        {t('form.save_changes')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
});

export default DateRangePicker;
